export const CLEAR_WIDGETS = "clearWidgets";
export const CLEAR_WIDGET = "clearWidget";
export const SET_WIDGET = "setWidget";
export const SET_WIDGETS = "setWidgets";
export const SET_ENABLED = "setEnabled";
export const SET_NAME = "setName";
export const SET_HOSTS = "setHosts";
export const SET_HOST_PATH = "setHostPath";
export const SET_HOST_SURVEY = "setHostSurvey";
export const ADD_HOST = "addHost";
export const REMOVE_HOST = "removeHost";
export const SET_MANUAL = "setManual";
export const SET_ACTIVATION = "setActivation";
export const SET_DEACTIVATION_RESPONSES = "setDeactivationByResponses";
export const SET_DEACTIVATION_DATE = "setDeactivationByDate";
export const SET_RESPONSES = "setResponses";
export const SET_START_DATE = "setStartDate";
export const SET_END_DATE = "setEndDate";
export const SET_VISUALIZATION = "setVisualization";
export const SET_DELAY = "setDelay";
export const SET_RECURRENCE = "setRecurrence";
export const SET_RECURRENCE_DAYS_RESPONDED = "setRecurrenceDaysResponded";
export const SET_RECURRENCE_DAYS_REFUSED = "setRecurrenceDaysRefused";
export const SET_EXHIBITION = "setExhibition";
export const SET_MINIMIZED = "setMinimized";
export const SET_SURVEY_COLOR = "setSurveyColor";
export const SET_PRIMARY_COLOR = "setPrimaryColor";
export const SET_SECONDARY_COLOR = "setSecondaryColor";
export const SET_THANKS_MESSAGE = "setThanksMessage";
export const SET_SURVEY = "setSurvey";
